import gql from 'graphql-tag'

import configureApolloClient from 'network/index'

const apolloClient = configureApolloClient()

export const CREATE_THEME_STATE = 'CREATE_THEME_STATE'
export const DESTROY_THEME_STATE = 'DESTROY_THEME_STATE'

export const SET_THEME_FONT = 'SET_THEME_FONT'
export const SET_THEME_COLOR = 'SET_THEME_COLOR'
export const SET_THEME_ELEVATION = 'SET_THEME_ELEVATION'
export const SET_THEME_ROUNDNESS = 'SET_THEME_ROUNDNESS'
export const SET_THEME_SPACING = 'SET_THEME_SPACING'

export const SAVE_THEME_CHANGES_REQUEST = 'SAVE_THEME_CHANGES_REQUEST'
export const SAVE_THEME_CHANGES_DATA_MERGE = 'SAVE_THEME_CHANGES_DATA_MERGE'
export const SAVE_THEME_CHANGES_SUCCESS = 'SAVE_THEME_CHANGES_SUCCESS'
export const SAVE_THEME_CHANGES_COMPLETE = 'SAVE_THEME_CHANGES_COMPLETE'

export const createThemeState = () => ({
  type: CREATE_THEME_STATE
})

export const destroyThemeState = () => ({
  type: DESTROY_THEME_STATE
})

export const setThemeFont = (key, value) => ({
  type: SET_THEME_FONT,
  key,
  value
})

export const setThemeColor = (key, value) => ({
  type: SET_THEME_COLOR,
  key,
  value
})

export const setThemeElevation = value => ({
  type: SET_THEME_ELEVATION,
  value
})

export const setThemeRoundness = value => ({
  type: SET_THEME_ROUNDNESS,
  value
})

export const setThemeSpacing = value => ({
  type: SET_THEME_SPACING,
  value
})

export const saveThemeChanges = (options = { silent: false }) => async (dispatch, getState) => {
  try {
    const { theme } = getState().project

    if (!options.silent) {
      dispatch({
        type: SAVE_THEME_CHANGES_REQUEST
      })
    }

    const response = await apolloClient.mutate({
      variables: {
        themeId: theme._id,
        fonts: {
          primary: { ...theme.fonts.primary, __typename: undefined }
        },
        colors: {
          primary: { ...theme.colors.primary, __typename: undefined },
          black: { ...theme.colors.black, __typename: undefined },
          white: { ...theme.colors.white, __typename: undefined }
        },
        elevation: theme.elevation,
        roundness: theme.roundness,
        spacing: theme.spacing
      },
      mutation: gql`
        mutation updateTheme(
          $themeId: ID!,
          $fonts: ThemeFontsInput!,
          $colors: ThemeColorsInput!,
          $elevation: Int!,
          $roundness: Int!,
          $spacing: Int!
        ) {
          updateTheme(
            themeId: $themeId,
            fonts: $fonts,
            colors: $colors,
            elevation: $elevation,
            roundness: $roundness,
            spacing: $spacing
          ) {
            _id
          }
        }
      `
    })

    dispatch({
      type: SAVE_THEME_CHANGES_DATA_MERGE,
      theme: response.data.updateTheme
    })

    if (!options.silent) {
      dispatch({
        type: SAVE_THEME_CHANGES_SUCCESS
      })

      setTimeout(() => {
        dispatch({
          type: SAVE_THEME_CHANGES_COMPLETE
        })
      }, 800)
    }
  } catch (error) {
    // todo: invoke notification
    console.log(error)
  }
}



// WEBPACK FOOTER //
// ./src/actions/theme.js